export const bytesToGigabyte = (bytes: number): number => bytes / (1000.0 * 1000 * 1000)
export const formatGigabyte = (bytes: number): string =>
  `${bytesToGigabyte(bytes).toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 })} GB`
